import React from 'react';
import ReportPageWithMonthWeekSwitch from './components/ReportPageWithMonthWeekSwitch';
import RequestsByWeekListBySKU from './components/week/RequestsByWeekListBySKU';
import RequestsByMonthListBySKU from './components/month/RequestsByMonthListBySKU';

function RequestsBySKU() {
  return (
    <ReportPageWithMonthWeekSwitch
      title="Requests by SKU"
      MonthList={RequestsByMonthListBySKU}
      WeekList={RequestsByWeekListBySKU}
      storageKey="report-group-by"
    />
  );
}

export default RequestsBySKU;
